// @ts-nocheck
import React, { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import * as action from '../Action/Verify_Code/Verify_Code_Action';
import { useAppDispatch, useAppSelector } from '../hooks';
import LoginLayout from './LoginLayout';

const UNIVERSITY_URL = 'https://avsight.northpass.com/app';

const Verify = ({
  setIsEmailSubmit,
  email,
  setPreferenceLoad,
  setShowChat,
  requestHelpData,
  setRequestHelpData,
}) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const verifyCodeLoading = useAppSelector((state) => state.VerifyCodeReducer);
  const [errors, setErrors] = useState({});
  const [code, setCode] = useState('');
  const codeRefFocus = useRef();
  const busy = verifyCodeLoading?.loading;

  const verifyCode = async (e) => {
    e.preventDefault();
    setErrors({});
    const customErrors = {};
    if (code === '') {
      customErrors.code = 'Please enter access code to continue.';
      codeRefFocus.current?.focus();
    }
    if (Object.keys(customErrors).length > 0) {
      setErrors(customErrors);
      return;
    }
    const param = { email: email, code: code };
    dispatch(action.verifyCode({ data: JSON.stringify(param) }))
      .then((response) => {
        if (response.status !== 1) {
          toast.error(response.message);
          return;
        }
        setPreferenceLoad(true);
        setIsEmailSubmit('');
        if (email) sessionStorage.setItem('copilotUserEmail', email);
        localStorage.setItem('reqData', JSON.stringify(response.data));
        setShowChat(true);
        if (window.location.pathname === '/login') {
          navigate('/', { replace: true });
        }
      })
      .catch((error) => {
        console.log(error);
        toast.error(error.message);
      });
  };

  const showNeedHelpModal = () => {
    setRequestHelpData({ ...requestHelpData, email: email, showNeedHelpModal: true });
  };

  const goBackToEmail = () => {
    setIsEmailSubmit('email');
  };

  return (
    <LoginLayout>
      <div className="login-form-card">
        <div className="login-form-card__accent" aria-hidden />
        <div className="login-form-card__body">
          <div className="login-form-brand text-center">
            <h1 className="login-form-title">Access code</h1>
            <p className="login-form-lead text-muted">
              Enter the 4-digit code we sent to <span className="fw-semibold text-body">{email || 'your email'}</span>.
            </p>
          </div>

          <form className="login-form" onSubmit={verifyCode} noValidate>
            <label className="form-label login-form-label" htmlFor="login-access-code">
              Code
            </label>
            <div className="input-group login-form-input-group mb-2">
              <span className="input-group-text login-form-input-icon" id="login-code-addon">
                <i className="fa-solid fa-key" aria-hidden />
              </span>
              <input
                id="login-access-code"
                className={`form-control login-form-control login-form-control--code ${errors?.code ? 'is-invalid' : ''}`}
                ref={codeRefFocus}
                type="text"
                inputMode="numeric"
                pattern="[0-9]*"
                autoComplete="one-time-code"
                maxLength={4}
                name="code"
                value={code}
                onChange={(e) => setCode(e.target.value.replace(/\D/g, '').slice(0, 4))}
                placeholder="••••"
                aria-describedby="login-code-addon"
                disabled={busy}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    verifyCode(e);
                  }
                }}
              />
            </div>
            {errors?.code && <div className="invalid-feedback d-block mb-3">{errors.code}</div>}

            <button
              type="submit"
              className="btn btn-primary w-100 login-form-submit mb-2 d-inline-flex align-items-center justify-content-center gap-2"
              disabled={busy}
            >
              {busy ? (
                <>
                  <span className="spinner-border spinner-border-sm" role="status" aria-hidden />
                  <span>Verifying…</span>
                </>
              ) : (
                <>
                  <span>Continue</span>
                  <i className="fa-solid fa-arrow-right" aria-hidden />
                </>
              )}
            </button>

            <button
              type="button"
              className="btn btn-outline-secondary w-100 login-form-secondary mb-3"
              onClick={goBackToEmail}
              disabled={busy}
            >
              <i className="fa-solid fa-arrow-left me-2" aria-hidden />
              Use a different email
            </button>

            <div className="text-center">
              <button
                type="button"
                className="btn btn-link btn-sm text-decoration-none login-form-help"
                onClick={() => showNeedHelpModal()}
                disabled={busy}
              >
                <i className="fa-solid fa-circle-question me-1" aria-hidden />
                Need help signing in?
              </button>
            </div>
          </form>

          <div className="login-form-meta text-center">
            <span className="login-form-meta-label text-muted small">Additional resource</span>
            <a className="login-form-meta-link" href={UNIVERSITY_URL} rel="noopener noreferrer" target="_blank">
              <i className="fa-solid fa-graduation-cap me-1" aria-hidden />
              AvSight University
            </a>
          </div>
        </div>
      </div>
    </LoginLayout>
  );
};

export default Verify;
